import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function Privacy() {
  usePageMeta('Privacy Policy', 'How Australia College collects, uses, and protects your information.');

  return (
    <section className="section">
      <div className="container legal">
        <span className="eyebrow">Legal</span>
        <h1>Privacy Policy</h1>
        <p>Last updated: August 2026</p>

        <p>
          This policy explains how Australia College ("we", "us", "our")
          handles information collected through this website. It does not
          cover the specific privacy practices of individual products
          (OneSchool Companion, Voceda, or SMS Tutor), which may have their
          own in-product privacy information.
        </p>

        <h2>Information we collect</h2>
        <p>
          When you use the contact form on this site, we collect the
          information you choose to provide — typically your name, email
          address, the topic you select, and the content of your message.
          We do not use tracking cookies or advertising trackers on this
          website.
        </p>

        <h2>How we use it</h2>
        <p>
          We use the information you submit solely to respond to your
          enquiry and, where relevant, to follow up about a product you've
          expressed interest in. We do not sell or rent your information
          to third parties.
        </p>

        <h2>Third-party services</h2>
        <p>
          Contact form submissions are processed using Formspree, a
          third-party form delivery service, which forwards messages to our
          inbox. Formspree's own privacy policy governs how they handle
          data in transit.
        </p>

        <h2>Children's privacy</h2>
        <p>
          This website is a general company and product information site
          and is not directed at children. Our education products are
          designed to be used by or on behalf of students under the
          supervision of a teacher, parent or guardian, and any
          product-specific handling of student data is described separately
          within that product.
        </p>

        <h2>Data retention</h2>
        <p>
          We retain contact form messages only for as long as needed to
          respond to and resolve your enquiry, unless you ask us to delete
          them sooner.
        </p>

        <h2>Your rights</h2>
        <p>
          You can ask us what information we hold about you, request a
          correction, or ask us to delete it, by reaching out through our{' '}
          <Link to="/contact">contact page</Link>.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this policy from time to time as our products and
          practices evolve. The "last updated" date at the top of this page
          reflects the most recent revision.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy can be sent through our{' '}
          <Link to="/contact">contact page</Link>.
        </p>
      </div>
    </section>
  );
}

export default Privacy;
